import Config from 'conf';
import bindSocketEvents from './binds';

export default socketMiddleware => {
    bindSocketEvents(socketMiddleware);
    let socketEmit = socketMiddleware.socketEmit.bind(socketMiddleware);
    let socketOn = socketMiddleware.socketOn.bind(socketMiddleware);

    return {
        sendPushNotification: function(form) {
            return new Promise((resolve, reject) => {
                const sendPushNotification = args => {
                    if (timeout) {
                        clearTimeout(timeout);
                        timeout = null;
                    }
                    socketMiddleware.off('sendPushNotificationFeedback', sendPushNotification);
                    if (!args.success) reject(new Error());
                    return resolve(args);
                };
                socketOn('sendPushNotificationFeedback', sendPushNotification);
                let timeout = setTimeout(function() {
                    timeout = null;
                    socketMiddleware.off('sendPushNotificationFeedback', sendPushNotification);
                    reject(new Error('pushNotification'));
                }, Config.timeout_long_socket_order);
                socketEmit('sendPushNotification', form);
            });
        }
    };
};



// WEBPACK FOOTER //
// ./environments/fhe/eventsSocket/PushNotification/index.js